var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-notification-list"},_vm._l((_vm.notifications),function(notification){return _c('notification-item',{key:notification.timestamp,attrs:{"notification":notification,"type":notification.type}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }